import { motion } from "framer-motion";
import { useLanguage } from "../../context/LanguageContext";

const PHOTOS = [
  { src: "/work4.jpg", span: "md:col-span-5", aspect: "aspect-[3/4]" },
  { src: "/work2.jpg", span: "md:col-span-7", aspect: "aspect-[16/10]" },
  { src: "/work1.jpg", span: "md:col-span-7", aspect: "aspect-[16/10]" },
  { src: "/work3.jpg", span: "md:col-span-5", aspect: "aspect-[3/4]" },
  { src: "/crack.mp4", span: "md:col-span-12", aspect: "aspect-video", video: true },
];

export const Gallery = () => {
  const { t } = useLanguage();
  return (
    <section id="gallery" data-testid="gallery-section" className="py-28 md:py-36 max-w-7xl mx-auto px-6">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8 }}
        className="mb-16"
      >
        <p className="font-mono-tech text-xs tracking-[0.25em] uppercase text-[#60A5FA] mb-6" data-testid="gallery-overline">
          {t.gallery.overline}
        </p>
        <h2 className="font-display font-bold tracking-tight leading-[1.05] text-4xl md:text-5xl lg:text-6xl max-w-3xl" data-testid="gallery-title">
          {t.gallery.title}
        </h2>
      </motion.div>

      <div className="grid md:grid-cols-12 gap-4">
        {PHOTOS.map((p, i) => (
          <motion.div
            key={p.src}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: (i % 2) * 0.1 }}
            data-testid={p.video ? "gallery-video" : `gallery-photo-${i}`}
            className={`group relative overflow-hidden rounded-2xl border border-white/10 ${p.span}`}
          >
            {p.video ? (
              <video
                autoPlay
                muted
                loop
                playsInline
                controls
                preload="auto"
                poster="/crack-poster.jpg"
                className={`w-full object-cover ${p.aspect}`}
              >
                <source src="/crack.webm" type="video/webm" />
                <source src={p.src} type="video/mp4" />
              </video>
            ) : (
              <img
                src={p.src}
                alt={t.gallery.captions[i]}
                loading="lazy"
                className={`w-full object-cover transition-transform duration-700 group-hover:scale-105 ${p.aspect}`}
              />
            )}
            <div className="absolute inset-0 bg-gradient-to-t from-[#020617]/85 via-transparent to-transparent opacity-80 group-hover:opacity-100 transition-opacity duration-500" />
            <div className="absolute bottom-5 left-5 right-5 flex items-end justify-between gap-4">
              <span className="font-mono-tech text-xs tracking-widest uppercase text-slate-200">
                {t.gallery.captions[i]}
              </span>
              <span className="font-mono-tech text-xs text-[#60A5FA] shrink-0">{String(i + 1).padStart(2, "0")}</span>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
